import { render, staticRenderFns } from "./ReceiptModal.vue?vue&type=template&id=061e7023&scoped=true&"
import script from "./ReceiptModal.vue?vue&type=script&lang=ts&"
export * from "./ReceiptModal.vue?vue&type=script&lang=ts&"
import style0 from "./ReceiptModal.vue?vue&type=style&index=0&id=061e7023&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061e7023",
  null
  
)

export default component.exports